export default __webpack_public_path__ + "static/media/staticLogo.243ac625.png";